import '@mui/x-tree-view/themeAugmentation'
import { Components, Theme } from '@mui/material'
import { treeItemClasses } from '@mui/x-tree-view/TreeItem'

declare module '@mui/x-tree-view/TreeItem' {
  interface TreeItemProps {
    /** Marks a row whose record the viewer may not open; the row stops inviting a click. */
    'data-restricted'?: boolean
  }
}

const CHEVRON_SIZE_PX = 12
// The connector line sits under the centre of the chevron, which the content's padding indents by this much.
const CHEVRON_INSET_PX = 5

export const MuiTreeItem: Components<Omit<Theme, 'components'>>['MuiTreeItem'] = {
  variants: [
    {
      // A restricted node is shown by its position only and cannot be opened, so it must not invite a click.
      props: { 'data-restricted': true },
      style: {
        [`& > .${treeItemClasses.content}`]: {
          cursor: 'default',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  ],
  styleOverrides: {
    content: ({ theme }) => ({
      padding: theme.spacing(1.5, 2.5),
      borderRadius: theme.shape['radius-md'],
      gap: theme.spacing(2),
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.bg.interactive.hover,
      },
      '&.Mui-selected, &.Mui-selected.Mui-focused, &.Mui-selected:hover': {
        backgroundColor: theme.palette.bg.interactive.active,
      },
    }),
    iconContainer: {
      width: `${CHEVRON_SIZE_PX}px`,
      height: `${CHEVRON_SIZE_PX}px`,
      '& svg': {
        fontSize: '14px',
      },
    },
    groupTransition: ({ theme }) => ({
      marginLeft: `${CHEVRON_SIZE_PX / 2 + CHEVRON_INSET_PX}px`,
      paddingLeft: theme.spacing(3),
      borderLeft: `${theme.strokeWidth.strong} solid ${theme.palette.border.subtle}`,
    }),
  },
}
